<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>Hunt with the Hounds</span></p>
<p class="authorname"><span>Mignon G. Eberhart</span></p>
<p class="center" style="margin-top:80px;"><span><img alt="title" src="xhtml/fig_02.jpg"/></span></p>
<p class="center"><span><b class="sans_normal">A MYSTERIOUSPRESS.COM BOOK</b></span></p>
<p class="center" style="margin-top:20px;"><span><img alt="title" src="xhtml/fig_01.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?e081934c